import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$u } from './bank-account-document-inputs.js';
import { d as defineCustomElement$t } from './bank-account-form-inputs2.js';
import { d as defineCustomElement$s } from './business-documents-on-file2.js';
import { d as defineCustomElement$r } from './custom-popper2.js';
import { d as defineCustomElement$q } from './form-control-checkbox2.js';
import { d as defineCustomElement$p } from './form-control-date2.js';
import { d as defineCustomElement$o } from './form-control-file2.js';
import { d as defineCustomElement$n } from './form-control-monetary-provisioning2.js';
import { d as defineCustomElement$m } from './form-control-number-masked2.js';
import { d as defineCustomElement$l } from './form-control-select2.js';
import { d as defineCustomElement$k } from './form-control-text2.js';
import { d as defineCustomElement$j } from './form-control-tooltip2.js';
import { d as defineCustomElement$i } from './business-additional-questions-form-step.js';
import { d as defineCustomElement$h } from './business-additional-questions-form-step-core.js';
import { d as defineCustomElement$g } from './business-bank-account-form-step.js';
import { d as defineCustomElement$f } from './business-bank-account-form-step-core.js';
import { d as defineCustomElement$e } from './business-core-info-form-step.js';
import { d as defineCustomElement$d } from './business-core-info-form-step-core.js';
import { d as defineCustomElement$c } from './business-owners-form-step.js';
import { d as defineCustomElement$b } from './business-owners-form-step-core.js';
import { d as defineCustomElement$a } from './business-representative-form-inputs.js';
import { d as defineCustomElement$9 } from './business-representative-form-step.js';
import { d as defineCustomElement$8 } from './business-representative-form-step-core.js';
import { d as defineCustomElement$7 } from './business-terms-conditions-form-step.js';
import { d as defineCustomElement$6 } from './identity-address-form.js';
import { d as defineCustomElement$5 } from './legal-address-form-step.js';
import { d as defineCustomElement$4 } from './legal-address-form-step-core.js';
import { d as defineCustomElement$3 } from './owner-form.js';
import { d as defineCustomElement$2 } from './owner-form-core2.js';
import { d as defineCustomElement$1 } from './owner-form-inputs2.js';

const PaymentProvisioningFormSteps = /*@__PURE__*/ proxyCustomElement(class PaymentProvisioningFormSteps extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.allowOptionalFields = false;
        this.componentStepMapping = {
            0: () => h("justifi-business-core-info-form-step", { businessId: this.businessId, authToken: this.authToken, ref: (el) => this.refs[0] = el, allowOptionalFields: this.allowOptionalFields }),
            1: () => h("justifi-legal-address-form-step", { businessId: this.businessId, authToken: this.authToken, ref: (el) => this.refs[1] = el, allowOptionalFields: this.allowOptionalFields }),
            2: () => h("justifi-additional-questions-form-step", { businessId: this.businessId, authToken: this.authToken, ref: (el) => this.refs[2] = el, allowOptionalFields: this.allowOptionalFields }),
            3: () => h("justifi-business-representative-form-step", { businessId: this.businessId, authToken: this.authToken, ref: (el) => this.refs[3] = el, allowOptionalFields: this.allowOptionalFields }),
            4: () => h("justifi-business-owners-form-step", { businessId: this.businessId, authToken: this.authToken, ref: (el) => this.refs[4] = el, allowOptionalFields: this.allowOptionalFields }),
            5: () => h("justifi-business-bank-account-form-step", { businessId: this.businessId, authToken: this.authToken, ref: (el) => this.refs[5] = el, allowOptionalFields: this.allowOptionalFields }),
            6: () => h("justifi-business-terms-conditions-form-step", { businessId: this.businessId, authToken: this.authToken, ref: (el) => this.refs[6] = el, onFormLoading: this.handleFormLoading, allowOptionalFields: this.allowOptionalFields }),
        };
    }
    get currentStepComponent() {
        return this.componentStepMapping[this.currentStep]();
    }
    render() {
        return (h("div", { key: 'f25bbaeeac7ea49b2d99f746af0aec7b637d879a', class: 'col-12 mb-4' }, this.currentStepComponent));
    }
}, [0, "justifi-payment-provisioning-form-steps", {
        "businessId": [1, "business-id"],
        "authToken": [1, "auth-token"],
        "refs": [16],
        "currentStep": [2, "current-step"],
        "allowOptionalFields": [4, "allow-optional-fields"],
        "handleFormLoading": [16, "handle-form-loading"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-payment-provisioning-form-steps", "bank-account-document-form-inputs", "bank-account-form-inputs", "business-documents-on-file", "custom-popper", "form-control-checkbox", "form-control-date", "form-control-file", "form-control-monetary-provisioning", "form-control-number-masked", "form-control-select", "form-control-text", "form-control-tooltip", "justifi-additional-questions-form-step", "justifi-additional-questions-form-step-core", "justifi-business-bank-account-form-step", "justifi-business-bank-account-form-step-core", "justifi-business-core-info-form-step", "justifi-business-core-info-form-step-core", "justifi-business-owners-form-step", "justifi-business-owners-form-step-core", "justifi-business-representative-form-inputs", "justifi-business-representative-form-step", "justifi-business-representative-form-step-core", "justifi-business-terms-conditions-form-step", "justifi-identity-address-form", "justifi-legal-address-form-step", "justifi-legal-address-form-step-core", "justifi-owner-form", "owner-form-core", "owner-form-inputs"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-payment-provisioning-form-steps":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PaymentProvisioningFormSteps);
            }
            break;
        case "bank-account-document-form-inputs":
            if (!customElements.get(tagName)) {
                defineCustomElement$u();
            }
            break;
        case "bank-account-form-inputs":
            if (!customElements.get(tagName)) {
                defineCustomElement$t();
            }
            break;
        case "business-documents-on-file":
            if (!customElements.get(tagName)) {
                defineCustomElement$s();
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$r();
            }
            break;
        case "form-control-checkbox":
            if (!customElements.get(tagName)) {
                defineCustomElement$q();
            }
            break;
        case "form-control-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$p();
            }
            break;
        case "form-control-file":
            if (!customElements.get(tagName)) {
                defineCustomElement$o();
            }
            break;
        case "form-control-monetary-provisioning":
            if (!customElements.get(tagName)) {
                defineCustomElement$n();
            }
            break;
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                defineCustomElement$m();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$l();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$k();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "justifi-additional-questions-form-step":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "justifi-additional-questions-form-step-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "justifi-business-bank-account-form-step":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "justifi-business-bank-account-form-step-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "justifi-business-core-info-form-step":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "justifi-business-core-info-form-step-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "justifi-business-owners-form-step":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "justifi-business-owners-form-step-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "justifi-business-representative-form-inputs":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "justifi-business-representative-form-step":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "justifi-business-representative-form-step-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "justifi-business-terms-conditions-form-step":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "justifi-legal-address-form-step":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "justifi-legal-address-form-step-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "justifi-owner-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "owner-form-core":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "owner-form-inputs":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { PaymentProvisioningFormSteps as P, defineCustomElement as d };
